import { ShieldCheck, Phone, Mail, MapPin, Star, MessageSquare, Store } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'
import { appRoutes } from '@/constants'

interface SellerCardProps {
  seller: {
    id?: number
    name: string
    type: string
    phone: string
    email: string
    location: string
    rating: number
    verified: boolean
  }
  onOpenChat?: () => void
}

export function SellerCard({ seller, onOpenChat }: SellerCardProps) {
  return (
    <Card className="p-6 rounded-2xl glass border border-white/10 space-y-6">
      <div className="flex items-center gap-4">
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 border border-primary/30 font-display text-xl font-bold text-primary">
          {seller.name.slice(0, 2).toUpperCase()}
        </div>
        <div>
          <div className="flex items-center gap-2">
            <h4 className="font-display text-lg font-bold text-foreground">{seller.name}</h4>
            {seller.verified && <ShieldCheck className="h-4 w-4 text-emerald-500" />}
          </div>
          <p className="text-xs text-muted-foreground">{seller.type}</p>
          <div className="flex items-center gap-1 text-xs text-amber-500 mt-1">
            <Star className="h-3.5 w-3.5 fill-amber-500" />
            <span className="font-semibold">{seller.rating} / 5.0 Rating</span>
          </div>
        </div>
      </div>

      <div className="space-y-3 pt-4 border-t border-border text-xs text-muted-foreground">
        <div className="flex items-center gap-2.5">
          <MapPin className="h-4 w-4 text-primary shrink-0" />
          <span>{seller.location}</span>
        </div>
        <div className="flex items-center gap-2.5">
          <Phone className="h-4 w-4 text-primary shrink-0" />
          <span>{seller.phone}</span>
        </div>
        <div className="flex items-center gap-2.5">
          <Mail className="h-4 w-4 text-primary shrink-0" />
          <span>{seller.email}</span>
        </div>
      </div>

      <div className="pt-2 space-y-3">
        <div className="grid grid-cols-2 gap-3">
          <Button size="sm" className="bg-primary text-primary-foreground hover:bg-primary/90 glow-md font-bold">
            <Phone className="mr-1.5 h-3.5 w-3.5" /> Call Seller
          </Button>
          <Button
            size="sm"
            variant="outline"
            onClick={onOpenChat}
            className="border-border text-foreground hover:bg-accent font-bold cursor-pointer"
          >
            <MessageSquare className="mr-1.5 h-3.5 w-3.5 text-primary" /> Message Seller
          </Button>
        </div>

        <Link to={appRoutes.cars} className="block w-full">
          <Button size="sm" variant="secondary" className="w-full font-bold text-xs gap-1.5 border border-primary/30 text-primary hover:bg-primary/10">
            <Store className="h-4 w-4" /> View Seller Inventory &amp; Storefront
          </Button>
        </Link>
      </div>
    </Card>
  )
}
